import { createContext, useReducer } from "react";
import * as types from "./types";

const initialState = {
  productCategoryList: {},
  productCategoryData: {},
  query: {},
};

const productCategoryReducer = (state, action) => {
  switch (action.type) {
    case types.GET_PRODUCT_CATEGORY_LISTING:
      return {
        ...state,
        productCategoryList: action.payload,
      };
    case types.GET_PRODUCT_CATEGORY_BY_ID:
      return {
        ...state,
        productCategoryData: action.payload,
      };
    case types.SET_QUERY:
      return {
        ...state,
        query: action.payload,
      };
    default:
      return state;
  }
};

export const ProductCategoryContext = createContext(initialState);

const ProductCategoryProvider = ({ children }) => {
  const [productCategoryState, productCategoryDispatch] = useReducer(
    productCategoryReducer,
    initialState
  );

  return (
    <ProductCategoryContext.Provider
      value={[productCategoryState, productCategoryDispatch]}
    >
      {children}
    </ProductCategoryContext.Provider>
  );
};

export default ProductCategoryProvider;